module.exports = __webpack_public_path__ + "pin_blue_bs_dot.fe79c8.png";